import { useEffect, useState } from 'react';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import './App.css';

import { useCookies } from 'react-cookie';
import { v4 as uuid } from 'uuid';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { AppShell } from './components/appShell';
import { MatchTable } from './components/matchTable';
import { PickTable } from './components/pickTable';
import { StateMessage } from './components/common';
import { MatchService } from './service/matchService';
import { useTheme } from './hooks/useTheme';
import { useIsDesktop } from './hooks/useIsDesktop';
import { startAnalytics } from './firebase';

startAnalytics();

function App() {
  const [leagues, setLeagues] = useState(null);
  const [leaguesError, setLeaguesError] = useState(false);
  const [cookies, setCookie] = useCookies(['user']);
  const [theme, toggleTheme] = useTheme();
  const isDesktop = useIsDesktop();

  useEffect(() => {
    MatchService.getLeagues()
      .then((rows) => setLeagues(Array.isArray(rows) ? rows : []))
      .catch(() => setLeaguesError(true));
  }, []);

  useEffect(() => {
    if (!cookies.UserToken) {
      setCookie('UserToken', uuid(), { path: '/' });
    }
  }, [cookies.UserToken, setCookie]);

  const page = (content) => (
    <AppShell leagues={leagues} leaguesError={leaguesError} theme={theme} onToggleTheme={toggleTheme} isDesktop={isDesktop}>
      {content}
    </AppShell>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={page(<MatchTable isDesktop={isDesktop} />)} />
        <Route path="/league/:area/:league" element={page(<MatchTable isDesktop={isDesktop} />)} />
        <Route path="/leagues" element={page(<MatchTable isDesktop={isDesktop} />)} />
        <Route path="/date/:date" element={page(<MatchTable isDesktop={isDesktop} />)} />
        <Route path="/mypicks" element={page(<PickTable userCookie={cookies.UserToken} isDesktop={isDesktop} />)} />
        <Route path="*" element={page(
          <StateMessage icon="pi-compass" title="Page not found" detail="Use the leagues menu or the date arrows to find matches." />
        )} />
      </Routes>
    </Router>
  );
}

export default App;
